import { createSlice } from "@reduxjs/toolkit";
import { getinstagramAdsList } from "./ThunkActions";
import {  REDUCER_NAME, IInstagramAdsState } from "./Types";

// Define initial state based on the provided structure
const initialState: IInstagramAdsState = {
  isLoading: false,
  instagramAdsList: [],
  errorMessage: null,
};

export const instagramAdsSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    resetinstagramAdsState: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getinstagramAdsList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getinstagramAdsList.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.instagramAdsList = payload.data.data;
          state.isLoading = false;
        }
      })
      .addCase(getinstagramAdsList.rejected, (state) => {
        state.errorMessage = "Failed to fetch Ads list";
        state.isLoading = false;
      });
  },
});

export const { resetinstagramAdsState } = instagramAdsSlice.actions;
export default instagramAdsSlice.reducer;
